import { useMenuHeaderRegistration } from '#pplx/frontend/aether/components/internal/menu/useMenuHeaderRegistry.js';
/** Renders content above and outside the menu's scrollable region. */
export function MenuHeader({ children }) {
    useMenuHeaderRegistration(children);
    return null;
}
//# sourceMappingURL=MenuHeader.js.map